const env = process.env.NEXT_PUBLIC_ENV;
const harmonyEnv = process.env.NEXT_PUBLIC_ENV_HARMONY;
export const isWeb = env === 'web';
export const isH5 = env === 'h5';
export const isMini = env === 'mini';
export const isNative = env === 'native';
export const isMobile = env !== 'web';
export const isHarmony = harmonyEnv === 'harmony';
const modeEnv = process.env.NEXT_PUBLIC_BUILD_ENV;
export const isProd = modeEnv === 'prod';

export const isOverseas = process.env.NEXT_PUBLIC_LOCALE === 'en';

export const brandName = isOverseas ? 'Hailuo' : 'MiniMax';

// // 根据ua判断是否是pc端
// export const isPc = /(Windows|Macintosh|Linux|Ubuntu|FreeBSD|Macintosh|Mac OS X|Mac OS|Mac OS X)/i.test(
//   navigator.userAgent,
// );
